import { FileLoader } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

const PRIMARY_DECODER_PATH =
  "https://image-s3.sm.mncdn.com/cdn.sugartech/mottobucket/draco/161/";
const FALLBACK_DECODER_PATH =
  "https://s3.eu-central-1.amazonaws.com/cdn.sugartech/mottobucket/draco/161/";

function loadDecoderLibrary(
  path: string,
  url: string,
  responseType: string,
  loader: DRACOLoader,
): Promise<unknown> {
  const fileLoader = new FileLoader(loader.manager);
  fileLoader.setPath(path);
  fileLoader.setResponseType(responseType);
  fileLoader.setWithCredentials(loader.withCredentials);
  return new Promise((resolve, reject) => {
    fileLoader.load(url, resolve, undefined, reject);
  });
}

/**
 * Tries the Medianova path first, then the S3 copy if that request fails.
 * three.js calls this for `draco_wasm_wrapper.js` and `draco_decoder.wasm`.
 */
class FallbackDRACOLoader extends DRACOLoader {
  _loadLibrary(url: string, responseType: string) {
    return loadDecoderLibrary(
      PRIMARY_DECODER_PATH,
      url,
      responseType,
      this,
    ).catch(() =>
      loadDecoderLibrary(FALLBACK_DECODER_PATH, url, responseType, this),
    );
  }
}

/**
 * Shared DRACOLoader. Each instance starts an Emscripten worker pool that
 * instantiates Draco WASM. A new loader per model eventually fails with
 * `WebAssembly.instantiate(): Out of memory: Cannot allocate Wasm memory`.
 */
export class DRACOLoaderSingleton {
  private static _instance: DRACOLoader;

  static getInstance(): DRACOLoader {
    if (!DRACOLoaderSingleton._instance) {
      DRACOLoaderSingleton._instance = new FallbackDRACOLoader().setDecoderPath(
        PRIMARY_DECODER_PATH,
      );
    }
    return DRACOLoaderSingleton._instance;
  }
}
